import { GETepicFactory } from '../../util/epicFactories';
import { prepareRegistrationsStatistics } from '../../util/helper';
import { noop } from '../../util/helper';

const prefix = `BEDARFSANMELDUNG_STATISTICS`;
export const FETCH_BEDARFSANMELDUNG_STATISTICS = `${prefix}/FETCH_BEDARFSANMELDUNG_STATISTICS`;

export const fetchBedarfsanmeldungStatisticsEpic = GETepicFactory(FETCH_BEDARFSANMELDUNG_STATISTICS, {
  url: (action) => {
    const { page = 0, size = 2147483647, von, bis, agsSelected } = action.payload;
    return `/api/v1/kita/admin/statistics/bedarfsanmeldungen?page=${page}&size=${size}&von=${von}&bis=${bis}&ags=${agsSelected}`;
  }
});

export const CLEAR_STORE = `${prefix}/CLEAR_STORE`;

export const fetchBedarfsanmeldungStatistics = (page = 0, size = 2147483647, von, bis, agsSelected, success = noop, error = noop) => fetchBedarfsanmeldungStatisticsEpic.run({
  von,
  bis,
  agsSelected,
  page: page,
  size: size,
}, {
  success,
  error
});

export const clearStore = () => ({
  type: CLEAR_STORE
});

const ACTION_HANDLERS = {
  ...fetchBedarfsanmeldungStatisticsEpic.ACTION_HANDLERS,
  [fetchBedarfsanmeldungStatisticsEpic.SUCCESS]: (state, action) => {
    return {
      ...state,
      tableProjection: prepareRegistrationsStatistics(state, action).tableProjection,
      tableFull: prepareRegistrationsStatistics(state, action).tableFull,
      isFetching: false, 
      hasError: false
    };
  },
  [fetchBedarfsanmeldungStatisticsEpic.FAIL]: (state, action) => {
    return {
      ...state,
      isFetching: false,
      hasError: true
    };
  },
  [fetchBedarfsanmeldungStatisticsEpic.START]: (state, action) => {
    return {
      ...state,
      isFetching: true
    };
  },
  [CLEAR_STORE]: (state, action) => {
    return {
      ...initialState
    };
  }
};

export const actions = {
  fetchBedarfsanmeldungStatistics,
  clearStore
};

export const epics = [
  fetchBedarfsanmeldungStatisticsEpic.epic
];

const initialState = {
  tableProjection: [],
  tableFull: [],
  isFetching: false,
  hasError: false
};

export function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default reducer;
